import Datatable from "./datatable.container";

export default Datatable;
